module.exports = __webpack_public_path__ + "static/media/ACS_CP250_Logo.313b4a43.png";